export const translations = {
  en: {
    welcomeMessage: "Hello! How can I help you today?",
    chatTitle: "Chat with us",
    inputPlaceholder: "Type a message...",
    errorMessage: "Sorry, I'm having trouble connecting right now. Please try again later.",
    minimize: "Minimize",
    close: "Close"
  },
  zhTW: {
    welcomeMessage: "您好！我能為您提供什麼協助？",
    chatTitle: "與我們對話",
    inputPlaceholder: "輸入訊息...",
    errorMessage: "抱歉，目前連線有問題。請稍後再試。",
    minimize: "最小化",
    close: "關閉"
  }
}; 